import React from 'react';
import { Search, Scale, TrendingUp } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Method() {
  const steps = [{
    icon: <Search size={24} className="text-white" data-id="element-127" />,
    title: 'Auditoría de Precisión',
    text: 'Analizamos tus tres reportes (Experian, Equifax y TransUnion) para detectar cada error que está hundiendo tu puntaje injustamente.'
  }, {
    icon: <Scale size={24} className="text-white" data-id="element-128" />,
    title: 'Disputa Estratégica Legal',
    text: 'No enviamos cartas genéricas. Utilizamos tácticas legales basadas en la FCRA para obligar a los burós a eliminar lo que no debe estar ahí.'
  }, {
    icon: <TrendingUp size={24} className="text-white" data-id="element-129" />,
    title: 'Educación y Crecimiento',
    text: 'Te guiamos para mantener tu puntaje en la cima. No solo arreglamos tu crédito, te enseñamos a dominar el juego del dinero en este país.'
  }];
  return <section className="py-24 lg:py-32 bg-brand-navy text-white overflow-hidden" data-id="element-130">
      <div className="max-w-7xl mx-auto px-6" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-133">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-134">
              Un proceso profesional. <br className="hidden md:block" data-id="element-135" />
              <span className="text-brand-amber" data-id="element-136">Resultados inevitables.</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-137">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-slate-800 -z-10" data-id="element-138" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-139">
              <div className="relative flex flex-col items-center text-center" data-id="element-140">
                <div className="w-16 h-16 bg-brand-amber rounded-full flex items-center justify-center mb-8 shadow-[0_0_30px_-5px_rgba(217,119,6,0.4)] z-10" data-id="element-141">
                  {step.icon}
                </div>
                <div className="absolute top-0 -left-4 text-8xl font-black text-slate-800/50 -z-10 select-none" data-id="element-142">
                  {index + 1}
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-143">{step.title}</h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-144">{step.text}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-145">
          <div className="text-center mt-16" data-id="element-146">
            <p className="text-slate-400 mb-6" data-id="element-147">
              ¿Quieres saber dónde estás parado? Obtén tu monitoreo de crédito
              ahora.
            </p>
            <a href="https://creditheroscore.com/redirect.asp?guid=0WXBQVBN6VZ4&sid=MKARES7S4" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-brand-amber text-brand-amber hover:bg-brand-amber hover:text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300" data-id="element-148">
              <TrendingUp size={20} data-id="element-149" />
              OBTENER MI MONITOREO DE CRÉDITO
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}